import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M8 3C4.818 3 2.102 5.074 1 8c1.102 2.927 3.818 5 7 5s5.899-2.073 7-5c-1.101-2.926-3.818-5-7-5m0 2c2.022 0 3.842 1.155 4.812 3-.97 1.845-2.79 3-4.812 3-2.022 0-3.841-1.155-4.812-3C4.159 6.156 5.978 5 8 5"
        />
        <path
          className="icon-color"
          d="M8.004 5.995c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2s2-.896 2-2c0-1.105-.896-2-2-2"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M12 5C7.454 5 3.572 7.902 2 12c1.572 4.098 5.454 7 10 7 4.545 0 8.427-2.902 10-7-1.573-4.098-5.455-7-10-7m0 2c3.353 0 6.347 1.938 7.823 5-1.476 3.062-4.47 5-7.823 5-3.354 0-6.348-1.938-7.823-5C5.652 8.938 8.647 7 12 7"
        />
        <path
          className="icon-color"
          d="M12.001 7.984c-2.21 0-4 1.791-4 4 0 2.21 1.79 4 4 4s4-1.79 4-4c0-2.209-1.79-4-4-4m0 2c1.103 0 2 .898 2 2 0 1.104-.897 2-2 2s-2-.896-2-2c0-1.102.897-2 2-2"
        />
      </g>
    </svg>
  ),
};
